import React from 'react'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">
              <span className="footer-icon">🚀</span>
              QR Code Generator
            </h3>
            <p className="footer-description">
              Create beautiful, customizable QR codes instantly. 
              Perfect for businesses, events, and personal use.
            </p>
            <div className="footer-features">
              <span className="feature-tag">⚡ Instant Generation</span>
              <span className="feature-tag">🎨 Customizable</span>
              <span className="feature-tag">📱 Mobile Friendly</span>
              <span className="feature-tag">🔒 Privacy First</span>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">Features</h4>
            <ul className="footer-list">
              <li>📄 Multiple Formats (PNG, SVG)</li>
              <li>🎯 Error Correction Levels</li>
              <li>🌈 Color Customization</li>
              <li>📏 Size Options</li>
              <li>📋 Copy to Clipboard</li>
              <li>📤 Share Functionality</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">Use Cases</h4>
            <ul className="footer-list">
              <li>🌐 Website URLs</li>
              <li>📧 Email Addresses</li>
              <li>📞 Phone Numbers</li>
              <li>👤 Contact Cards</li>
              <li>📶 WiFi Networks</li>
              <li>💬 Custom Messages</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">About Sutralink</h4>
            <p className="footer-description">
              Empowering digital innovation through elegant simplicity. 
              Creating tools that inspire and enable meaningful connections.
            </p>
            <div className="footer-links">
              <a href="#privacy" className="footer-link">Privacy Policy</a>
              <a href="#terms" className="footer-link">Terms of Service</a>
              <a href="#contact" className="footer-link">Contact</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-info">
            <p className="copyright">
              © {currentYear} QR Code Generator. Powered by{' '}
              <span className="brand">Sutralink</span>
            </p>
            <p className="footer-note">
              Built with React, Vite, and qrcode.js
            </p>
          </div>
          
          <div className="footer-social">
            <a href="#github" className="social-link" aria-label="GitHub">
              <span className="social-icon">🐙</span>
            </a>
            <a href="#twitter" className="social-link" aria-label="Twitter">
              <span className="social-icon">🐦</span>
            </a>
            <a href="#linkedin" className="social-link" aria-label="LinkedIn">
              <span className="social-icon">💼</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 